import { z } from 'zod';
/** The monthly cloud limit per user (doc 60), in US dollars as RunPod bills them. */
export const CLOUD_LIMIT_USD = Object.freeze({ min: 1, max: 100_000 });
export const SetCloudLimitRequestSchema = z.object({ limitUsd: z.number().min(CLOUD_LIMIT_USD.min).max(CLOUD_LIMIT_USD.max).nullable() });
/** A stop by the guard: when, why, which pods. */
export const CloudGuardStopSchema = z.object({ at: z.string(), reason: z.string(), pods: z.array(z.string()) });
/** This month's spend at RunPod for the pods Couch made (from RunPod's billing), the limit, the last check. */
export const CloudSpendSchema = z.object({
    month: z.string(),
    spentUsd: z.number().nullable(),
    checkedAt: z.string().nullable(),
    limitUsd: z.number().nullable(),
    error: z.string().nullable(),
    lastStop: CloudGuardStopSchema.nullable(),
});
export const CloudSpendResponseSchema = z.object({ spend: CloudSpendSchema });
export const usd = (amount) => `$${amount.toFixed(2)}`;
//# sourceMappingURL=cloud-guard.js.map